import request from '@/router/axios'

//创建题库
export function createSubjectLib (obj) {
  return request({
    url: '/exam/admin/subject-lib',
    method: 'post',
    data: obj,
  })
}

//题库详情
export function getSubjectLibDetail (id) {
  return request({
    url: `/exam/admin/subject-lib/${id}`,
    method: 'get',
  })
}

//题库列表
export function getSubjectLibList (param) {
  return request({
    url: '/exam/admin/subject-libs',
    method: 'get',
    params: param,
  })
}

//删除题库
export function deleteSubjectLib (id) {
  return request({
    url: `/exam/admin/subject-lib/${id}`,
    method: 'delete',
  })
}

//编辑题库
export function editSubjectLib (obj) {
  return request({
    url: `/exam/admin/subject-lib/${obj.id}`,
    method: 'put',
    data: obj,
  })
}